<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Pace #</label>
          <el-input placeholder="Input data"
                    v-model="filters.essentials.paceNumber.value"
                    clearable></el-input>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Client</label>
          <el-select
              v-model="filters.essentials.client.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getMetadataTagValues('client')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Business Unit</label>
          <el-select
              v-model="filters.essentials.businessUnit.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getMetadataTagValues('product_area')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Project Number / CMI#</label>
          <el-input placeholder="Input data"
                    v-model="filters.essentials.cmiNumber.value"
                    clearable></el-input>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Category</label>
          <el-select
              v-model="filters.essentials.category.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getMetadataTagValues('category')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Product</label>
          <el-select
              v-model="filters.essentials.product.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues()"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getMetadataTagValues('product_type')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Region of the study</label>
          <el-select :value="filters.essentials.region.value" @change="val => changeRegionData(val, 'essentials')"
                     placeholder="Select data" multiple filterable collapse-tags>
            <el-option-group label="Press Tab/Escape to exit">
              <template v-for="value in getMetadataTagValues('region')">
                <el-option
                    v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value.value)"
                    :key="value.value" :label="value.value"
                    :value="value.value">
                  <span style="float: left">{{value.value}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                </el-option>
              </template>
              <template v-for="value in getAPACcounts()">
                <el-option v-if="value.value === 'APAC'" :key="value.value" :label="value.value"
                           :value="value.value">
                  <span style="float: left">{{value.value}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                </el-option>
                <el-option v-else :key="value.value" :label="value.value"
                           :value="value.value">
                  <span style="float: left; margin-left: 10px">{{value.value}}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                </el-option>
              </template>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <div class="d-flex">
            <label style="margin-right: 5px">Country of the study</label><div v-b-tooltip.hover.html="tooltips.comparingScored"><font-awesome-icon icon="info-circle"></font-awesome-icon></div>
          </div>
          <el-select v-model="filters.essentials.country.value" placeholder="Select data" multiple filterable collapse-tags
                     @change="updateDropdownValues()">
            <el-option-group label="Press Tab/Escape to exit">
              <el-option v-for="value in getMetadataTagValues('country')" :key="value.value"
                         @change="updateDropdownValues()"
                         :label="value.value"
                         :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center justify-content-center">
        <div class="input-wrapper" style="margin-top: 17px; width: 90%;">
          <label>Year</label>
          <div class="slider-wrapper">
            <el-slider
                v-if="yearInput && Object.keys(yearInput).length"
                v-model="yearInput.value"
                range
                :min="yearInput.min"
                :max="yearInput.max"
                :marks="yearInput.marks"
                @change="[parseYears(), updateDropdownValues()]"
                show-stops
            >
            </el-slider>
          </div>
        </div>
        <!--<div class="d-flex justify-content-center align-items-center w-100"-->
        <!--style="margin-top: -5px; margin-left: -45px;">-->
        <!--<el-checkbox class="ml-5" v-model="yearInput.includeMissing">Include files without a year-->
        <!--</el-checkbox>-->
        <!--</div>-->
      </div>
      <div v-if="userPermissions.isAdmin" class="col-6 d-flex flex-column align-items-left">
        <div style="height: 40px; margin-top: 17px" class="d-flex align-items-center mr-2">
          <span class="mr-2 threshold-text" :class="{'text-active': filters.essentials.verified.value }">Search not verified studies only</span>
          <ToggleButton class="toggle-switch" :labels="{checked: 'No', unchecked: 'Yes'}" :value="true"
                        :color="{checked: 'rgba(0, 0, 0, 0.15)', unchecked: '#78BB95'}" :sync="true"
                        v-model="filters.essentials.verified.value" @change="updateDropdownValues()"></ToggleButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tooltips from '../../../constants/tooltips'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import generalGetters from '../../../store/modules/general/getterTypes'

export default {
  name: 'EssentialsForm',
  props: {
    filters: Object,
    getMetadataTagValues: Function,
    updateDropdownValues: Function,
    getAPACcounts: Function,
    yearRange: Array,
    yearInput: Object
  },
  data () {
    return {
      tooltips,
      previousRegionValues: []
    }
  },
  methods: {
    changeRegionData (data, targetObj) {
      const mainRegion = 'APAC'
      const subRegions = ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia']
      if (data.includes(mainRegion)) {
        if (!this.previousRegionValues.includes(mainRegion)) {
          data = [...new Set([...data, ...subRegions])]
        } else {
          if (data.filter(el => el !== mainRegion).length < 3) {
            const index = data.indexOf(mainRegion)
            data.splice(index, 1)
          }
        }
      } else {
        if (this.previousRegionValues.includes(mainRegion)) {
          data = data.filter(x => !subRegions.includes(x))
        }
      }
      this.$set(this.filters[targetObj].region, 'value', data)
      this.previousRegionValues = data
      this.updateDropdownValues(_.cloneDeep(this.filters))
    },
    parseYears () {
      this.filters.essentials.startYear.value = this.yearInput.value[0]
      this.filters.essentials.endYear.value = this.yearInput.value[1]
    },
    resetYearInput () {
      this.yearInput.value = [this.yearInput.min, this.yearInput.max]
    }
  },
  computed: {
    ...mapGetters({
      userPermissions: generalGetters.GET_PERMISSIONS
    })
  },
  watch: {
    yearRange (newValue) {
      if (newValue.length) {
        let min = newValue[0]
        let max = newValue[1]
        this.yearInput = {
          min,
          max,
          value: newValue,
          marks: {},
          includeMissing: true
        }
        this.yearInput.marks[min] = min.toString()
        this.yearInput.marks[max] = max.toString()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";
.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.toggle-switch {
  margin-bottom: 0;
}

.threshold-text {
  font-size: 13px;
  color: #78BB95;
  transition: color 0.2s linear;
  white-space: nowrap;
}

.text-active {
  color: rgba(0, 0, 0, 0.2);
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}

</style>
